import { Expose, Type } from "class-transformer";
import type { ProfileCompletionLevelEnum } from "../../../../../features/profile/constants/profile-completion-level.enum";
import { ProfileSectionDto } from "../profile-section/profile-section.dto";
import type { IProfileSectionDto } from "../profile-section/profile-section.dto.interface";
import type { IProfileCompletionDto } from "./profile-completion.dto.interface";

export class ProfileCompletionDto implements IProfileCompletionDto {
  @Expose()
  @Type(() => ProfileSectionDto)
  sections!: IProfileSectionDto[];

  @Expose()
  activeStep!: ProfileCompletionLevelEnum;
}
